import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {Observable, of as observableOf} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';

import * as suelosActions from './suelos.actions';
import {SueloService} from "../../../../../chacra-core";

@Injectable()
export class SuelosEffects {
  SuelosLoadRequestEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<suelosActions.SuelosLoadRequestAction>(
      suelosActions.SuelosActionTypes.SUELOS_LOAD_REQUEST
    ),
    switchMap(() => {
      return this.suelosCoreService.getSuelosCoreMeta().pipe(
        map(suelos => new suelosActions.SuelosLoadSuccessAction({
            items: suelos
          })
        ),
        catchError(error =>
          observableOf(
            new suelosActions.SuelosLoadFailureAction({
              error
            })
          )
        )
      );
    })
  ));

  // load

  constructor(
    private suelosCoreService: SueloService,
    private actions$: Actions
  ) {
  }
}
